import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import Footer from '../../components/Footer/Footer';
import TitleBar from '../../components/TitleBar/TitleBar';
import PrimaryButtonCard from '../../components/PrimaryButtonCard/PrimaryButtonCard';
import Assistant from '../../components/Assistant/Assistant';
import './Home.scss';

//icons
import searchIcon from '../../assets/search.png';
import eyeIcon from '../../assets/eye.png';

//text
import assistantText from '../../assets/text/text.json';
import { loadContentForPage, pushAndStop } from '../../redux/actions/text.action';
import Search from '../../services/Search.service';

import { setSearchTerm } from '../../redux/actions/result.action';
import Div100vh from 'react-div-100vh';

/**
 * Home page component
 */

class Home extends Component<{ navigateTo: any, setCurrentpage: any, setSearch: any }, {}> {

    componentDidMount() {
        //this.props.setCurrentpage();
    }

    constructor(props: any) {
        super(props);
    }
    /**
     * Main render method of component
     */
    render() {
        return (
            <div className="home">
                <TitleBar noNavigation={true}/>
                <Assistant textLine1={assistantText.home.Assistant.line1} textLine2={assistantText.home.Assistant.line2} text={["Ich suche was", "Zeig mir was"]}></Assistant>
                <div className="home-btn-container">
                    <PrimaryButtonCard text="Ich suche was" icon={searchIcon} action={() => {
                        this.props.navigateTo('/selectinput')
                    }} />
                    <PrimaryButtonCard text="Zeig mir was" icon={eyeIcon} action={() => {
                            this.props.navigateTo('/random')
                    }} />
                </div>
                <Footer></Footer>
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {

    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        navigateTo(path: string) {
            dispatch(pushAndStop(path));
        },
        setCurrentpage() {
            dispatch(loadContentForPage("home"));
        },
        setSearch(term: any) {
            dispatch(setSearchTerm(term));
            dispatch(pushAndStop('/result'))
        }
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Home);
